import PropTypes from 'prop-types'
import React from 'react'

import Orders from 'components/Orders'

// Orders component handles resizing and other features..
export const EditOrder = (props) =>
  <Orders {...props} routeIntention='form' editing />

EditOrder.propTypes = {
  order: PropTypes.object,
  orders: PropTypes.array.isRequired,
  pricelist: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired,
  uoms: PropTypes.array.isRequired,
  routes: PropTypes.array,
  customers: PropTypes.array,

  onSubmit: PropTypes.func, // actual submit function
  handleSubmit: PropTypes.func.isRequired, // redux-form function
  handleDelete: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,

  isAdmin: PropTypes.bool,

  dispatch: PropTypes.func.isRequired
}

EditOrder.defaultProps = {
  order: {},
  orders: [],
  pricelist: [],
  options: [],
  uoms: [],
  routes: [],
  customers: []
}

export default EditOrder



// WEBPACK FOOTER //
// ./src/components/Orders/Edit/EditOrder.js